<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        :style="{ backgroundColor }">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.502 6.70495L19.3851 4.58801L8.79511 15.168L4.62619 10.9991L2.49658 13.1137L8.79494 19.4121L21.502 6.70495Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
